import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';

let itemChecked2 = [];
export default class EditarUsuario extends Component {

    constructor(props) {
        super(props); 

        this.state = {
            key: 0,
            categoriaLongitud:0,
            resource: {
				nFuenteOrigen: 4650,
                nUsuTipoAutenticacion: 884,
                nUsuTipoUsuario: 886,
                sUsuNombre: "",
                sUsuApellidoPaterno: "",
                sUsuApellidoMaterno: "",
                sUsuEmail: "",
                sUsuContrasenia: "",
                nUbiCodigo: 1350,
                sUsuDireccion: "",
                sUsuCadenaActivacion: "",
                sUsuTelefono: "",
                sUsuCelular: "",
                sectores: [
                    {
                    nTipSector: 1
                    }
                ],
                activo: true,
                nRolUsuCodigo:0,
                nRolCodigo:0,
				nUsuActivo: 1,
                nRolCodigoNuevo:0,
                rol:{}
            },
            Validacion: {
                sUsuNombre: {
                    Error: false,                    
                },
                sUsuApellidoPaterno: {
                    Error: false,                    
                },
                sUsuApellidoMaterno: {
                    Error: false,                    
                },
                sUsuEmail: {
                    Error: false,                    
                },
                sUsuContrasenia: {
                    Error: false,                    
                },
                nRolCodigoNuevo: {
                    Error: false,                    
                }
            },
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[],
            pagina:1,
            rolesAsignar:[],
            itemChecked2:[],
        }

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    onCheck = (id, event) => {
        
        const target = event.target;

        if(target.type === 'checkbox'){
            let rolesAsignar = this.state.rolesAsignar.slice();

            if(event.target.checked){
                if(rolesAsignar.indexOf(id) === -1){
                    rolesAsignar.push(id);
                }
            }else{
                let indice = rolesAsignar.indexOf(id);

                if ( indice !== -1 ) {
                    rolesAsignar.splice( indice, 1 );
                }
            }

            this.setState({
                rolesAsignar: rolesAsignar
            });
        }
    }

    loadRoles = (page = 1) => {

        const url = `${API_URL}RolUX/listar/${page}/4650`;
        axios.get(url).then(response => response.data)
        .then((data) => {

            $(".ipl-progress-indicator-head").css({"width": "100%"});
			setTimeout(function()
			{
				$(".ipl-progress-indicator").hide();
				$(".ipl-progress-indicator-head").css({"width": "0%"});
            }, 200);
            
            this.setState({ roles: data.result, pagina: 1});

            this.ShowPaginationFive(page-1);

            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log('Error de comunicación');
        });

    }

    /* PAGINACIÓN */
    executePaginationPrev(page, e){
		if(!$(".divPaginador a.active").prev().hasClass("btnPrevPaginador"))
		{			
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))-1, e);
		}
	}
	
	executePaginationNext(page, e){
		if(!$(".divPaginador a.active").next().hasClass("btnNextPaginador"))
		{
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))+1, e);
		}
	}

    executePagination(page, e){

        if(e != undefined){
            e.preventDefault();
        }

        var entity = this.state.roles.length>0?this.state.roles[0]:null;

        for(let index=0; index < entity.totalPages+2; index++)
        {
            if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }
        
        if($("#"+page).is("*")){
			document.getElementById(page).classList.add("active");
		}

		$(".ipl-progress-indicator").fadeIn();
        $(".ipl-progress-indicator-head").css({"width": "90%"});
        
        this.loadRoles(page);
    }

    paginationTable(){
        var entity = this.state.roles.length > 0 ? this.state.roles[0] : null;

        const options = [];

		if (entity !== null)
		{
            if(entity.totalPages <= 1){
                return null;
            }

            options.push(<a className="btnPrevPaginador" id={0} key={0} onClick={(e) => this.executePaginationPrev(0, e)}></a>);
            
            for(let index=1; index < entity.totalPages+1; index++)
                options.push(<a className="pageItem" id={index} key={index} onClick={(e) => this.executePagination(index, e)}> {index} </a>);

            options.push(<a className="btnNextPaginador" id={entity.totalPages+1} key={entity.totalPages+1} onClick={(e) => this.executePaginationNext(entity.totalPages+1, e)}></a>);

        return (
            <div className="divPaginador" key={"pagination"} id="pagination">
                {options}
            </div>
        );
        }
    }
	
	ShowPaginationFive(pagina){
		$(".divPaginador a.active").removeClass("active");
		$(".divPaginador a:eq("+pagina+")").next().addClass("active");
		
		$(".divPaginador .pageItem").hide();
		
		let ItemPage = parseInt($(".divPaginador a.active").prop("id"));
		if(ItemPage < 4){
			$(".divPaginador .pageItem").slice(0,5).show();
		}
		else if(ItemPage < 5){
			$(".divPaginador .pageItem").slice(1,6).show();
		}
		else if(ItemPage < 6){
			$(".divPaginador .pageItem").slice(2,7).show();
		}
		else if(ItemPage >= 6){
			$(".divPaginador .pageItem.active").prev().prev().show();
			$(".divPaginador .pageItem.active").prev().show();
			$(".divPaginador .pageItem.active").show();
			$(".divPaginador .pageItem.active").next().show();
			$(".divPaginador .pageItem.active").next().next().show();
		}
		
		if(!$(".pageItem.active").next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().show()
		  }
		}
		if(!$(".pageItem.active").next().next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().prev().show()
		  }
		}
    }
    /* FIN PAGINACIÓN */

    componentDidMount(){

        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/usuarios";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 

        this.loadRoles();
    }

    componentWillMount(){
        
        var key = this.props.match.params.id;
        const url = `${API_URL}UsuarioUX/ObtenerUsuarioById/${key}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            let resource = data.result;
            let rolesAsignar = [];

            if(resource != null){

                data.result["nRolUsuCodigo"] = 0;
                data.result["nRolCodigoNuevo"] = 0;
                data.result["nRolCodigo"] =  0;

                if(resource.cRolesxUsuario.length > 0)
                {
                    // Mantenemos el primer rol en estos campos por compatibilidad con el resto de la pantalla,
                    // pero rolesAsignar ahora refleja TODOS los roles ya asignados al usuario, no solo el primero.
                    let rol = resource.cRolesxUsuario[0];
                    data.result["nRolCodigo"] =  rol.nRolCodigo;
                    data.result["nRolUsuCodigo"] = rol.nRolUsuCodigo;
                    data.result["rol"] = rol;

                    resource.cRolesxUsuario.forEach((r) => {
                        rolesAsignar.push(r.nRolCodigo);
                        itemChecked2["check_" + r.nRolCodigo] = true;
                    });

                }
            }


            this.setState({ resource: data.result, response: data, error: data.Error, itemChecked2, rolesAsignar:rolesAsignar });           

        })
        .catch(error => {
            toast.error("¡Error al inicializar!");
        });
    
    }
    
    handleClickCancel(e) {

        if(e != undefined){
            e.preventDefault();
        }

        const {history: {push}} = this.props;    
        push('/usuarios');
     }

    callFunctionButton = (event) => {

        let newState = this.state;
        newState.hasError = false;

        let rolesAsignar = this.state.rolesAsignar;

        if (newState.resource.sUsuNombre == '') {  
            
            newState.Validacion.sUsuNombre = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.sUsuApellidoPaterno == '') {  
            newState.Validacion.sUsuApellidoPaterno = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.sUsuApellidoMaterno == '') {  
            newState.Validacion.sUsuApellidoMaterno = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.sUsuEmail == '') {  
            newState.Validacion.sUsuEmail = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.sUsuContrasenia == '') {  
            newState.Validacion.sUsuContrasenia = {Error: true};
            newState.hasError = true;
        }
        if (rolesAsignar.length == 0) {  
            toast.error("Seleccione al menos un rol");
            newState.Validacion.nRolCodigoNuevo = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}UsuarioUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'nUsuCodModificacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(url, JSON.stringify(formData),{ 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then((data)=> {             
            
            if (data.data.isSucess){
                let stateResponse = this.state;

                stateResponse.added = true;

                this.setState(stateResponse);
                let resource = this.state.resource;

                // Roles que ya tenía el usuario al abrir la pantalla (con su nRolUsuCodigo real)
                const rolesOriginales = resource.cRolesxUsuario || [];

                // Marcados ahora pero que el usuario no tenía antes -> insertar
                const rolesNuevos = rolesAsignar.filter(
                    nRolCodigo => !rolesOriginales.some(r => r.nRolCodigo === nRolCodigo)
                );

                // Los tenía antes pero ya no están marcados -> eliminar
                // (el backend interpreta nRolCodigo=0 en ActualizarUsuarioRol como eliminación de esa fila rol-usuario)
                const rolesQuitados = rolesOriginales.filter(
                    r => rolesAsignar.indexOf(r.nRolCodigo) === -1
                );

                rolesNuevos.forEach((nRolCodigo) => {
                    this.registrarRolUsuario(resource.nUsuCodigo, nRolCodigo, resource.nUsuCodModificacion);
                });

                rolesQuitados.forEach((rolQuitado) => {
                    this.actualizarRolUsuario({
                        nRolUsuCodigo: rolQuitado.nRolUsuCodigo,
                        nRolCodigo: 0,
                        nUsuCodigo: resource.nUsuCodigo,
                        nUsuCodModificacion: resource.nUsuCodModificacion
                    });
                });

                setTimeout(() => { 
                    this.handleClickCancel();
                }, 1000);  

                setTimeout(() => { 
                    this.setState({added:false});
                }, 5000); 
            
            } else {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
        });        
    }

    registrarRolUsuario = (nUsuCodigo = 0, nRolCodigo = 0, nUsuCodCreacion = 0) => {

        let url = `${API_URL}UsuarioUX/RolUsuario`;
        var dataForm = {
            "nRolCodigo": nRolCodigo,
            "nUsuCodigo": nUsuCodigo,
            "nUsuCodCreacion": nUsuCodCreacion,
            "activo": true
          };

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                console.log("Rol registrado");
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        
        this.setState({loading:false});
        }); 
    }

    actualizarRolUsuario = (rolUsuario = null) => {
        
        if(rolUsuario == null){return;}

        let url = `${API_URL}UsuarioUX/ActualizarUsuarioRol`;

        const formData = JSON.stringify(rolUsuario);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                console.log("Rol actualizado");
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        
        this.setState({loading:false});
        }); 
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones
        });     
    }

    render() {

        console.log("Roles", this.state.rolesAsignar);

        return (
            <div className="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/permisos">
                            / Usuarios
                        </Link>
                        <Link to="/usuarios">
                            / Lista de usuarios
                        </Link>
                        <span> / Editar Usuario</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Usuario
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar la actualización.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se actualizó el registro correctamente. Se redireccionará al listado.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Nombres" name='sUsuNombre' 
                        value={this.state.resource.sUsuNombre} maxLength={255} 
                        className={this.state.Validacion.sUsuNombre.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>
                    
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Apellido Paterno" name='sUsuApellidoPaterno' 
                        value={this.state.resource.sUsuApellidoPaterno} maxLength={255} 
                        className={this.state.Validacion.sUsuApellidoPaterno.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Apellido Materno" name='sUsuApellidoMaterno' 
                        value={this.state.resource.sUsuApellidoMaterno} maxLength={255} 
                        className={this.state.Validacion.sUsuApellidoMaterno.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Correo Electrónico" name='sUsuEmail' 
                        value={this.state.resource.sUsuEmail} maxLength={255} 
                        className={this.state.Validacion.sUsuEmail.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Contraseña" name='sUsuContrasenia' 
                        value={this.state.resource.sUsuContrasenia} maxLength={20} 
                        className={this.state.Validacion.sUsuContrasenia.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                    <input type="text" placeholder="Expo Token" name='expoPushToken' 
                        value={this.state.resource.expoPushToken}
                        readOnly/>
                    </div>

                    <div className="txtSelect-Radio">
                        <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Asignar rol:</b></p>
                        <div style={{height: 250, overflowX: 'hidden', overflowY: 'scroll', border: '1px solid #DBDCDB', borderRadius: 4, boxShadow: 'inset 1px 1px 2px 0px rgb(228, 228, 228)', paddingLeft: 10, paddingTop: 10, paddingBottom: 10}}>
                            {
                                this.state.roles.length > 0 ?
                                this.state.roles.map((rol) => (
                                    <div className="inputRadio" style={{width: '100%', display: 'block'}}>
                                        <input type="checkbox" 
                                            style={{WebkitAppearance: 'checkbox'}} 
                                            name={"check_" + rol.nRolCodigo} 
                                            checked={this.state.rolesAsignar.includes(rol.nRolCodigo)}  
                                            onClick={(event) => this.onCheck(rol.nRolCodigo, event)}
                                        />
                                        <label>
                                            {rol.sRolNombre}
                                        </label>
                                    </div> 
                                )) : null
                            }                           
                        </div>
                        {this.paginationTable()}
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo noneEvent"  onClick={(event) => this.callFunctionButton(event)}>ACTUALIZAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}
